export const workExperiences = [
  {
    id: "enpal-senior-software-engineer",
    company: "Enpal B.V.",
    title: "Senior Software Engineer",
    duration: "Dec 2025 - Present",
    location: "Berlin, Germany",
    description: [
      "Working on the scalability and reliability of Enpal's sales opportunity workflow.",
    ],
    technologies: ["Distributed Systems", "Workflow Design", "Scalability", "Reliability"],
  },
  {
    id: "avalanche-studios-senior-backend-engineer",
    company: "Avalanche Studios",
    title: "Senior Backend Engineer",
    duration: "Jan 2025 - Nov 2025",
    location: "Stockholm, Sweden",
    description: [
      "Worked on the architecture and delivery of the live operations platform and backend services for an upcoming AAA title.",
      "Collaborated across teams and with publishing partners to translate product requirements into reliable and observable services.",
      "Implemented and managed Azure infrastructure with Terraform, Helm, and CI/CD practices.",
      "Built services for high-concurrency workloads with strict SLAs at a project scale of roughly 500k all-time active players.",
    ],
    technologies: ["C#", ".NET", "Golang", "Azure", "Terraform", "Helm", "CI/CD", "Observability"],
  },
  {
    id: "ringtail-interactive-senior-software-engineer",
    company: "Ringtail Interactive",
    title: "Senior Software Engineer",
    duration: "Nov 2021 - Dec 2024",
    location: "Stockholm, Sweden",
    description: [
      "Designed and shipped game server platform features with a focus on fault tolerance, scalability, and failure isolation.",
      "Worked with multiple teams to turn unclear requirements into designs and delivery plans.",
      "Improved the release process through automation and Azure DevOps CI/CD, and mentored engineers across the backend guild.",
      "Designed and delivered a custom CI/CD solution that supported smoother customer onboarding onto the platform.",
    ],
    technologies: ["Golang", ".NET", "Azure DevOps", "CI/CD", "Game Platform", "Mentoring"],
  },
  {
    id: "shell-senior-software-engineer-tech-lead",
    company: "Shell",
    title: "Senior Software Engineer / Tech Lead",
    duration: "Aug 2016 - Nov 2021",
    location: "Bangalore, India",
    description: [
      "Worked as a senior engineer and tech lead in a cross-functional team of about 10 people across backend, frontend, data, and QA.",
      "Helped reduce release cadence from multi-month to monthly by introducing CI/CD and trunk-based workflows.",
      "Delivered pipelines and models with PySpark and Databricks, and automated QA with Selenium and Python.",
      "Provisioned infrastructure with Terraform across Azure and AWS, and introduced monitoring and incident playbooks.",
      "Supported ingestion and processing at a scale of roughly 500k rows per day.",
    ],
    technologies: ["C#", "Golang", "Python", "PySpark", "Databricks", "Terraform", "Azure", "AWS", "CI/CD"],
  },
  {
    id: "cognizant-associate",
    company: "Cognizant",
    title: "Associate",
    duration: "Apr 2016 - May 2016",
    location: "Kolkata, India",
    description: [
      "Built web APIs with Node and Express, contributed to front-end work with HTML, CSS, and Angular, and worked with containerized delivery.",
    ],
    technologies: ["Node.js", "Express", "Angular", "HTML", "CSS", "Containers"],
  },
  {
    id: "wipro-project-engineer",
    company: "Wipro",
    title: "Project Engineer",
    duration: "Nov 2011 - Mar 2016",
    location: "Kolkata, India and London, UK",
    description: [
      "Worked on ASP.NET and WCF applications backed by SQL Server, including Classic ASP and IIS administration in production environments.",
    ],
    technologies: ["ASP.NET", "WCF", "SQL Server", "Classic ASP", "IIS", "Production Support"],
  },
];
